module.exports = __webpack_public_path__ + "static/img/new_chat.df0764d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/new_chat.png
// module id = MhK5
// module chunks = 1